export const LANGUAGE_EVENTS = {
    GET_LANGUAGE: "GET_LANGUAGE",
    CHANGE_PORTAL_NAME: "CHANGE_PORTAL_NAME",
};

//#region -- Get Language

export const GET_LANGUAGE = {
    START: "GET_LANGUAGE_START",
    SUCCESS: "GET_LANGUAGE_SUCCESS",
};

const defaultGetLanguageState = {
    getLanguageData: false,
    getLanguageLoading: false,
};
//#endregion

//#region -- Change Portal

export const CHANGE_PORTAL_NAME = {
    START: "CHANGE_PORTAL_START",
    SUCCESS: "CHANGE_PORTAL_SUCCESS",
};

const defaultPortalNameState = {
    agentPortalName: null,
    guestPortalName: null,
};
//#endregion

const defaultState = {
    ...defaultGetLanguageState,
    ...defaultPortalNameState,
};

const languageReducer = (state = defaultState, action = {}) => {
    switch (action.event) {
        case LANGUAGE_EVENTS.GET_LANGUAGE:
            return {
                ...state,
                getLanguageLoading: action.type === GET_LANGUAGE.START,
                getLanguageData: action.type === GET_LANGUAGE.SUCCESS ? action.payload : false,
            };
        case LANGUAGE_EVENTS.CHANGE_PORTAL_NAME:
            return {
                ...state,
                agentPortalName: action.type === CHANGE_PORTAL_NAME.SUCCESS ? action.payload.agentPortalName : null,
                guestPortalName: action.type === CHANGE_PORTAL_NAME.SUCCESS ? action.payload.guestPortalName : null,
            };
        default:
            return state;
    }
};

export default languageReducer;
